import { render, staticRenderFns } from "./OfficeAndRecords.vue?vue&type=template&id=3fb9e81c&scoped=true&"
import script from "./OfficeAndRecords.vue?vue&type=script&lang=js&"
export * from "./OfficeAndRecords.vue?vue&type=script&lang=js&"
import style0 from "./OfficeAndRecords.vue?vue&type=style&index=0&id=3fb9e81c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb9e81c",
  null
  
)

export default component.exports